import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import SocialIntegrations from './SocialIntegrations';
import GoogleAnalyticsSettings from './GoogleAnalyticsSettings';

export default function IntegrationsTab() {
  return (
    <div className="space-y-6">
      <Card className="bg-white border-gray-border">
        <CardHeader>
          <CardTitle className="text-lg font-heading">Social Media Platforms</CardTitle>
        </CardHeader>
        <CardContent>
          <SocialIntegrations />
        </CardContent>
      </Card>

      <GoogleAnalyticsSettings />

      <Card className="bg-white border-gray-border">
        <CardContent className="p-4 flex items-center justify-between flex-wrap gap-3">
          <div className="text-sm text-gray-medium">
            Looking for HubSpot / Salesforce / Zoho / Shopify / WooCommerce?
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.href = '/settings/integrations'}
            data-testid="goto-integrations-hub"
          >
            Open Integrations Hub
          </Button>
        </CardContent>
      </Card>
      <Card className="bg-white border-gray-border">
        <CardContent className="p-4 flex items-center justify-between flex-wrap gap-3">
          <div className="text-sm text-gray-medium">
            Connect Meta / Google Ads / LinkedIn / TikTok Ads accounts
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.href = '/settings/ad-accounts'}
            data-testid="goto-ad-accounts"
          >
            Open Ad Accounts
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
